import React, { useEffect, useState } from "react";
import Human from "../../assets/human.png";
import "./layout.css";
import Search from "../../assets/Images/search.png";
import { useNavigate } from "react-router-dom";

const TopBar = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  useEffect(() => {
    const user = localStorage.getItem("state");
    const userInfo = JSON.parse(user);
    setUser(userInfo);
  }, []);
  return (
    <div style={{ paddingTop: "0px" }}>
      <nav
        className="navbar navbar-expand-lg navbar-light bg-white"
        id="custom-top"
      >
        <div className="container-fluid">
          {/* <a className="navbar-brand" href="#">Navbar</a> */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <form className="me-auto">
              {/* <input
                className="form-control me-2 shadow-none"
                type="search"
                placeholder="Search"
                aria-label="Search"
                style={{
                  paddingLeft: "36px",
                  background: "rgba(245, 246, 250, 1)",
                  borderRadius: "20px",
                  border: "1px solid rgba(213, 213, 213, 1)",
                  width: 380,
                }}
              />
              <img
                src={Search}
                width={16}
                style={{ position: "absolute", top: 29, left: 23 }}
              /> */}
            </form>

            <ul className="navbar-nav mb-2 mb-lg-0 me-3 my-auto">
              <li className="nav-item dropdown mx-4 profil">
                <a
                  className="nav-link dropdown-toggle d-flex"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="d-flex ">
                    <img src={Human} width={40} height={40} />
                    <div className="my-auto" style={{ marginLeft: 10 }}>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "rgba(73, 73, 73, 1)",
                        }}
                      >
                        {user?.user?.Name}
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 400,
                          color: "rgba(73, 73, 73, 1)",
                        }}
                      >
                        {user?.user?.Role}
                      </div>
                    </div>
                  </div>
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li
                    onClick={() => {
                      localStorage.clear();
                      navigate("/login");
                    }}
                  >
                    <a className="dropdown-item" href="javascript:void(0)">
                      Log Out
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default TopBar;
